import { render } from "./Persons.vue?vue&type=template&id=542032e1&scoped=true"
import script from "./Persons.vue?vue&type=script&lang=js"
export * from "./Persons.vue?vue&type=script&lang=js"

import "./Persons.vue?vue&type=style&index=0&id=542032e1&lang=scss"
import "./Persons.vue?vue&type=style&index=1&id=542032e1&lang=scss&scoped=true"

import exportComponent from "/Users/bruno/Documents/projects/pixeon-c/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-542032e1"]])

export default __exports__